import ProjectPage from './ProjectsPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const ProjectsPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/projects',
      component: ProjectPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/projects/ProjectsPageConfig.js